import { useTranslation } from 'react-i18next';
import MyProgressTab from '@/components/dashboard/MyProgressTab.tsx';

export default function ProgressPage() {
  const { t } = useTranslation();
  return (
    <div className="animate-fade-in">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          {t('dashboard.tabProgress', 'Progreso')}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('progress.subtitle', 'Tu evolución en puntuaciones y KPIs')}
        </p>
      </header>
      <MyProgressTab />
    </div>
  );
}
